import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngx-datatable-footer-template]'
})
export class DataTableFooterTemplateDirective {
  template = inject<TemplateRef<unknown>>(TemplateRef);

}
